import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'OperatorSelector.label',
    defaultMessage: 'Operator',
  },
});
